export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export const parseString = (valor, idioma) => {
  if (typeof valor === 'number') return valor
  if ((idioma === 0 || idioma === 2) && valor) {
    if (valor[valor.length - 3] === '.') return parseFloat(valor)
    return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
  } else if (valor) {
    return parseFloat(valor.replace(/[,]/g, ''))
  }
  return 0
}

export const parseMoney = (valor, idioma) => {
  if ((idioma === 0 || idioma === 2) && valor) {
    return parseFloat(valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.'))
  } else if (valor) {
    return parseFloat(valor.replace('U$', '').replace(/[,]/g, ''))
  }
  return 0
}

export const parsePorcentagem = (valor, idioma) => {
  if ((idioma === 0 || idioma === 2) && valor) {
    return parseFloat(valor.replace('%', '').replace(/[.]/g, '').replace(/[,]/g, '.'))
  } else if (valor) {
    return parseFloat(valor.replace('%', '').replace(/[,]/g, ''))
  }
  return 0
}

export const sortObject = (obj) => {
  let values = Object.values(obj).sort((a, b) => {
    return a.valor > b.valor ? -1 : a.valor < b.valor ? 1 : 0
  })
  obj = {}
  values.forEach(el => { obj[el.id] = el })
  return obj
}

export const escapeRegExp = (text) => {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
}
export const replaceSpecialChars = (str) => {
  str = str.replace(/[ÀÁÂÃÄÅ]/, 'A')
  str = str.replace(/[àáâãäå]/, 'a')
  str = str.replace(/[ÈÉÊË]/, 'E')
  str = str.replace(/[èéê]/, 'e')
  str = str.replace(/[ìíî]/, 'i')
  str = str.replace(/[ÌÍÎ]/, 'I')
  str = str.replace(/[òóô]/, 'o')
  str = str.replace(/[ÒÓÔ]/, 'O')
  str = str.replace(/[ùúûü]/, 'u')
  str = str.replace(/[ÙÚÛÜ]/, 'U')
  str = str.replace(/[Ç]/, 'C')
  str = str.replace(/[ç]/, 'c')
  str = str.replace(/[Ñ]/, 'N')
  str = str.replace(/[ñ]/, 'n')

  // o resto

  return str.replace(/[^a-z0-9]/gi, '')
}
